// Client-side id generator for unique asset filenames (see utils/upload.ts — uploads are keyed
// hopdrive-learning-modules/<moduleKey>/<genId('asset')>). Module `content` is a plain markdown
// string with no embedded ids; row ids are bigserial, assigned by the DB — not generated here.

let seq = 1000;

/** Unique-enough string id, e.g. genId('asset') → 'asset_1001_483920'. */
export function genId(prefix: string): string {
  seq += 1;
  return `${prefix}_${seq}_${Math.floor(Math.random() * 1e6)}`;
}
